import { NeutralButton } from "../common/Buttons"
import { useState } from "react"
import useStore from "../../store"
import { tdeAuditAppUrl } from "../../constants/apiUrl"
import ActionConfirmDrawer from "../common/ActionConfirmDrawer"

export default function StartDealerAuditButton({ dealer }) {
  const tdeToken = useStore((state) => state.tdeToken)

  const [isOpen, setIsOpen] = useState(false)

  const currentFieldAuditId = dealer?.current_field_audit_id

  const buttonText = () => {
    return currentFieldAuditId ? 'Resume Audit' : 'Start Full Dealer Audit'
  }

  const goToAudit = () => {
    const params = new URLSearchParams({ token: tdeToken ?? '' })
    if (currentFieldAuditId) {
      params.append('field_audit_id', currentFieldAuditId)
    } else {
      params.append('dealer_id', dealer.id)
    }
    window.location.href = `${tdeAuditAppUrl}?${params.toString()}`
  }

  const handleButtonClick = () => {
    if (currentFieldAuditId) {
      goToAudit()
    } else {
      setIsOpen(true)
    }
  }

  return (
    <>
      <NeutralButton
        text={buttonText()}
        onClick={handleButtonClick}
      />
      <ActionConfirmDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCancel={() => setIsOpen(false)}
        onConfirm={goToAudit}
        placement="bottom"
        title={`Audit ${dealer?.name ?? 'Dealer'}`}
        body={`Start a full dealer audit for ${dealer?.name ?? 'this dealer'}?`}
      />
    </>
  )
}
